import {ApiService} from "../api";
import {CVVersion} from "../../types";
import {AxiosResponse} from "axios";
import {CVVersionRequestDTO} from "../../types/DTOs/CVVersionRequestDTO";
import {CVVersionResponseDTO} from "../../types/DTOs/CVVersionResponseDTO";
import {Log} from "../../utils/Log";

export class CvVersionAPI extends ApiService {
    private constructor() {
        super();
    }

    async getCVVersions(): Promise<CVVersionResponseDTO[]> {
        const response: AxiosResponse<CVVersionResponseDTO[]> = await this.api.get('/cv/versions');
        return response.data;
    }

    async getCVVersion(id: string): Promise<CVVersion> {
        const response: AxiosResponse<CVVersion> = await this.api.get(`/cv/versions/${id}`);
        return response.data;
    }

    async createCVVersion(data: CVVersionRequestDTO): Promise<CVVersion> {
        const response: AxiosResponse<CVVersion> = await this.api.post('/cv/versions', data);
        return response.data;
    }

    async updateCVVersion(id: string, data: CVVersionRequestDTO): Promise<CVVersion> {
        Log.writeLogDebug("Passato in put");
        const response: AxiosResponse<CVVersion> = await this.api.put(`/cv/versions/${id}`, data);
        return response.data;
    }

    async deleteCVVersion(id: string): Promise<void> {
        await this.api.delete(`/cv/versions/${id}`);
    }
}